module.exports = __webpack_public_path__ + "static/media/navigo-service-icon.dade1335.svg";